import axios from "axios";
import Config from "src/config";

const v1_actionWboEditarTemplate = (clienteId, templateId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/${templateId}`,
        data
    });
};

export default v1_actionWboEditarTemplate;
